import { Grid2, Typography } from "@mui/material";
import useUIBp from "../../../../../../../../Hooks/useUIBoilerplate";
import CollapseGrid from "../../../../../../../UI/GeneralPurpose/CollapseGrid";
import { defaultRadioSelect } from "../../../../../../../UI/GeneralPurpose/genericIDs";
import RadioSelect from "../../../../../../../UI/GeneralPurpose/RadioSelect";
import AddressInfo from "../AddressInfo/AddressInfo";
import DeliveryWindow from "../DeliveryWindow";

const UIText = {
  "es-CL": {
    subtitle: "Modalidad de recuperación",
    encrypt: "Encriptación de la información",
  },
  "en-US": {
    subtitle: "Recovery mode",
    encrypt: "Information encryption",
  },
};

const UITextLink = {
  "es-CL": { label: "Vínculo de descarga" },
  "en-US": { label: "Download link" },
};

const UITextHDD = {
  "es-CL": { label: "Disco duro" },
  "en-US": { label: "Hard drive" },
};

const UITextEncryptNo = {
  "es-CL": { label: "No encriptar información" },
  "en-US": { label: "Do not encrypt data" },
};
const UITextEncryptYes = {
  "es-CL": { label: "Encriptar información" },
  "en-US": { label: "Encrypt data" },
};

export const encryptData = "encryptData";

const DeliveryMode = () => {
  const { settings, UI } = useUIBp();
  const mode = UI[defaultRadioSelect] ?? "link";
  const locale = settings.locale;
  const { subtitle, encrypt } = UIText[locale];

  return (
    <Grid2 container size={12}>
      <Grid2 container {...{ size: 12, paddingBottom: 2 }}>
        <Typography fontWeight="bold">{subtitle}</Typography>
      </Grid2>
      <RadioSelect
        allowEmpty
        {...{
          id: defaultRadioSelect,
          value: "link",
          UIText: UITextLink,
          labelProps: { noWrap: true },
          size: 6,
        }}
      />
      <RadioSelect
        allowEmpty
        {...{
          id: defaultRadioSelect,
          value: "disk",
          UIText: UITextHDD,
          labelProps: { noWrap: true },
          size: 6,
        }}
      />
      <Grid2 container {...{ size: 12, paddingBottom: 2, paddingTop: 2 }}>
        <Typography fontWeight="bold">{encrypt}</Typography>
      </Grid2>
      <RadioSelect
        {...{
          id: encryptData,
          value: "encryptNo",
          UIText: UITextEncryptNo,
          labelProps: { noWrap: true },
          size: 6,
        }}
      />
      <RadioSelect
        {...{
          id: encryptData,
          value: "encryptYes",
          UIText: UITextEncryptYes,
          labelProps: { noWrap: true },
          size: 6,
        }}
      />
      <CollapseGrid open={mode === "link" ? false : true}>
        <AddressInfo />
        <DeliveryWindow />
      </CollapseGrid>
    </Grid2>
  );
};

export default DeliveryMode;
